import axios from 'axios';
import { AUTH_TOKEN_NAME, VERSION_TOKEN_NAME, BASE_URL } from '../const';

function checkDomain(url) {
  const pattern = /^(https?:\/\/(?:sso[\w\-]*\.shihuo\.cn|sso[\w\-]*\.shizhi-inc\.com))/;
  return pattern.test(url);
}

// 创建axios实例
const service = axios.create({
  baseURL: BASE_URL, // node环境的不同，对应不同的baseURL
  timeout: 20000, // 请求的超时时间
  // headers: {
  //   'Authorization': localStorage.getItem(`${AUTH_TOKEN_NAME}`) || ''
  //   // 'Content-Type': 'application/x-www-form-urlencoded',
  // },
  withCredentials: true, // 允许携带cookie
});

service.interceptors.request.use(
  (config) => {
    if(VERSION_TOKEN_NAME[window.SSO_TOKEN_VERSION]){
      config.headers[VERSION_TOKEN_NAME[window.SSO_TOKEN_VERSION]] = localStorage.getItem(`${AUTH_TOKEN_NAME}`) || '';
    }
    // 本地环境判断添加，来源各个子系统注入
    if(window.EP_SSO_CODE && checkDomain(config.baseURL)){
      config.headers['epsso-code'] = window.EP_SSO_CODE;
    }
    return config;
  },
  (error) => {
    // 错误处理代码
    return Promise.reject(error);
  },
);


// response拦截器
service.interceptors.response.use(
  (response) => {
    
    // 数据响应之后，要做的业务
    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default service;
